import {Component, Input, OnInit} from '@angular/core';
import {ICountDown, ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import { timer } from 'rxjs';
import {CommonService} from '@app/feature/store-editor/services/common.service';
@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.css']
})
export class COUNTDOWNComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  @Input() logic = false;
  isClosed = false;
  constructor(public cs: CommonService) { }


  ngOnInit() {
    this.item.data = this.cs.setDefaultSetting(this.item.data);
    this.oberserableTimer();
  }

  countDown(time: number): ICountDown {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

    const countDown = new Date(time).getTime();

    const now = new Date().getTime(),
      distance = countDown - now;
    this.isClosed = distance < 0;
    if (distance < 0) {
      return {
        day: 0,
        sec: 0,
        min: 0,
        hour: 0
      };
    } else {
      return {
        day: Math.floor(distance / (day)),
        hour: Math.floor((distance % (day)) / (hour)),
        min: Math.floor((distance % (hour)) / (minute)),
        sec: Math.floor((distance % (minute)) / second)
      };
    }
  }
  oberserableTimer() {
    const source = timer(1000, 1000);
    source.subscribe(val => {
      this.refreshCountDown();
    });
  }

  refreshCountDown() {
    this.item.data.countdown = {
      day: this.countDown(this.item.data.time).day,
      hour: this.countDown(this.item.data.time).hour,
      min: this.countDown(this.item.data.time).min,
      sec: this.countDown(this.item.data.time).sec,
    };
  }
}
